// extracted by mini-css-extract-plugin
module.exports = {"profileCardWrapper":"profilecard_profileCardWrapper__tZPOA","infoWrapper":"profilecard_infoWrapper__1gMME"};